import { useState } from "preact/hooks";
import type { Folders } from "../api";
import { SYSTEM_NAMES } from "../format";
import { Icon } from "./icons";

export type BulkAction =
  | { kind: "move"; to: string; label: string }
  | { kind: "read"; read: boolean }
  | { kind: "forever" };

// Barre d'actions de la sélection multiple, à la place de l'en-tête de la liste.
// here : dossier affiché, ou null pour des résultats de recherche venus de plusieurs dossiers.
export function SelectionBar({ count, total, here, folders, onAll, onClear, onAction }: {
  count: number;
  total: number;
  here: string | null;
  folders: Folders | null;
  onAll: () => void;
  onClear: () => void;
  onAction: (action: BulkAction) => void;
}) {
  const [menu, setMenu] = useState(false);
  const inTrash = here === "trash";
  const destinations = [
    { id: "inbox", name: "Boîte de réception" },
    ...(folders?.custom ?? []).map((f) => ({ id: f.id, name: f.name })),
    { id: "archive", name: SYSTEM_NAMES.archive },
    { id: "spam", name: SYSTEM_NAMES.spam },
  ].filter((d) => d.id !== here);

  return (
    <div class="list-head selection-bar">
      <button class="icon-btn" aria-label="Annuler la sélection" title="Annuler la sélection" onClick={onClear}><Icon name="close" /></button>
      <strong class="selection-count">{count}</strong>
      {count < total && <button class="link-btn" onClick={onAll}>Tout</button>}
      <span class="spacer" />
      {inTrash ? (
        <>
          <button class="icon-btn" title="Restaurer" aria-label="Restaurer"
            onClick={() => onAction({ kind: "move", to: "inbox", label: "restaurée" })}><Icon name="restore" /></button>
          <button class="icon-btn danger" title="Supprimer définitivement" aria-label="Supprimer définitivement"
            onClick={() => onAction({ kind: "forever" })}><Icon name="trash" /></button>
        </>
      ) : (
        <>
          {here !== "archive" && (
            <button class="icon-btn" title="Archiver" aria-label="Archiver"
              onClick={() => onAction({ kind: "move", to: "archive", label: "archivée" })}><Icon name="archive" /></button>
          )}
          <button class="icon-btn" title="Supprimer" aria-label="Supprimer"
            onClick={() => onAction({ kind: "move", to: "trash", label: "mise à la corbeille" })}><Icon name="trash" /></button>
        </>
      )}
      <button class="icon-btn" title="Marquer comme lu" aria-label="Marquer comme lu" onClick={() => onAction({ kind: "read", read: true })}><Icon name="read" /></button>
      <button class="icon-btn" title="Marquer comme non lu" aria-label="Marquer comme non lu" onClick={() => onAction({ kind: "read", read: false })}><Icon name="unread" /></button>
      <div style="position: relative">
        <button class="icon-btn" title="Déplacer" aria-label="Déplacer vers…" aria-expanded={menu} onClick={() => setMenu(!menu)}><Icon name="move" /></button>
        {menu && (
          <div class="menu menu-right" role="menu">
            {destinations.map((d) => (
              <button role="menuitem" onClick={() => { setMenu(false); onAction({ kind: "move", to: d.id, label: `déplacée vers « ${d.name} »` }); }}>{d.name}</button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
